import axios from "axios";
import { useState, useEffect } from "react";
import config from "../../../config";
import CustomSelect from "../../customSelect";
import { Transition } from "@headlessui/react";

import { check_login } from "../../../auth/auth";
import { check_permission } from "../../../auth/auth";

function LidBewerken(props) {
	const [claims] = useState(check_login(true));
	const [allowed] = useState(check_permission("praesidium", true));

	const [notification, setNotification] = useState({ show: false, msg: "" });

	const [naam, setNaam] = useState("");
	const [gsm, setGsm] = useState("");

	const [functie, setFunctie] = useState({ id: -1, value: "Kies een functie..." });
	const [functies, setFuncties] = useState([]);

	const [image, setImage] = useState(null);

	function voegLidToe() {
		let fd = new FormData();
		fd.append("name", naam);
		fd.append("gsm", gsm);
		fd.append("functie", functie.id);

		if (image instanceof File || image === null) {
			fd.append("image", image);
		}

		axios
			.put(config.api_url + "/praesidium-lid/" + props.lidID + "/", fd, {
				headers: {
					"content-type": "multipart/form-data",
				},
			})
			.then(() => {
				notify(<p className="text-zinc-200">Aanpassen van {naam} succesvol!</p>);
				props.reRender();
			});
	}

	useEffect(() => {
		axios.get(config.api_url + "/praesidium-lid/" + props.lidID + "/").then((res) => {
			setNaam(res.data.name);
			setGsm(res.data.gsm);
			setFunctie({ id: res.data.functie.id, value: res.data.functie.name });
			setImage(res.data.image);
		});
	}, []);

	useEffect(() => {
		axios.get(config.api_url + "/functies/?sort=order").then((response) => {
			let data = [];
			response.data.map((item) => {
				data.push({ id: item.id, value: item.name });
			});
			setFuncties(data);
		});
	}, []);

	function verwijderLid() {
		if (window.confirm("Bevestig het verwijderen van " + naam + ".")) {
			axios.delete(config.api_url + "/praesidium-lid/" + props.lidID + "/").then((response) => {
				notify(<p className="text-red-200">Verwijderen van {naam} succesvol!, sluit dit scherm</p>);
				props.reRender();
			});
		} else {
		}
	}
	function notify(msg) {
		setNotification({ show: true, msg: msg });
		setTimeout(() => {
			setNotification({ show: false, msg: msg });
		}, 5000);
	}
	return (
		<>
			{!!claims && allowed && (
				<div className="my-8 mx-auto w-full lg:w-11/12 relative">
					<h2 className="mb-4 font-bold text-zinc-600 text-2xl text-center">{naam} bewerken</h2>
					<Transition show={notification.show} enter="transition-opacity duration-150" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity duration-150" leaveFrom="opacity-100" leaveTo="opacity-0">
						<div className="fixed bottom-4 right-6 z-[1000] bg-zinc-800 px-6 py-3 text-zinc-200 rounded-md shadow-md max-w-m">{notification.msg}</div>
					</Transition>
					<label htmlFor="naam" className="text-lg font-light text-zinc-600 dark:text-zinc-500">
						Voornaam & naam
					</label>
					<input id="naam" value={naam} onChange={(e) => setNaam(e.target.value)} type="text" className="border border-zinc-300 focus:outline-none focus:ring-1 focus:ring-blue-600 bg-transparent dark:border-zinc-700 w-full rounded-md px-3 py-2 dark:text-zinc-500 mb-4" placeholder="Vb: Rein Vanbelleghem" />
					<div className="flex items-center mb-2">
						<label htmlFor="gsm" className="text-lg font-light text-zinc-600 dark:text-zinc-500">
							Gsmnummer
						</label>
					</div>
					<input id="gsm" value={gsm} onChange={(e) => setGsm(e.target.value)} type="tel" className="border border-zinc-300 focus:outline-none focus:ring-1 focus:ring-blue-600 bg-transparent dark:border-zinc-700 w-full rounded-md px-3 py-2 dark:text-zinc-500 mb-4" placeholder="Vb: +32 494 11 11 11" />

					<label htmlFor="Functie" className="text-lg font-light text-zinc-600 dark:text-zinc-500">
						Functie
					</label>

					<CustomSelect options={functies} chosen={functie} setChosen={setFunctie} />

					<div className="mt-6">
						<label htmlFor="image" className="text-lg font-light text-zinc-600 dark:text-zinc-500 flex items-center gap-2">
							<span>Foto</span>
							<button onClick={() => setImage(null)} className="bg-orange-600 text-white px-2 py-1 text-xs rounded-md">
								<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
									<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
								</svg>
							</button>
						</label>
						<label className="flex flex-row w-52 mt-3 justify-center items-center px-3 py-3 bg-white dark:bg-zinc-800 dark:text-zinc-300 rounded-lg tracking-wide transition-colors uppercase border border-zinc-200 dark:border-zinc-700 hover:ring-1 hover:ring-blue-700 cursor-pointer hover:text-blue-700 dark:hover:ring-blue-400 dark:hover:text-blue-400">
							<svg className="w-6 h-6" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
								<path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
							</svg>
							<span className="ml-2 text-base leading-normal">Foto uploaden</span>
							<input
								id="image"
								type="file"
								className="hidden"
								onChange={(event) => {
									setImage(event.target.files[0]);
								}}
							/>
						</label>
					</div>

					{image ? <img alt={naam} src={image instanceof File ? URL.createObjectURL(image) : image} className="w-28 h-28 md:w-32 md:h-32 rounded-full absolute bottom-1 right-1" /> : ""}

					<button onClick={() => voegLidToe()} className="bg-blue-700 text-md px-6 py-2 text-white font-bold rounded-lg mt-8 hover:bg-blue-200 hover:text-blue-800 transition-colors flex items-center">
						Aanpassen
					</button>

					<button onClick={() => verwijderLid()} className="absolute bottom-0 right-0 text-red-400 p-2 rounded-full bg-white border">
						<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
						</svg>
					</button>
				</div>
			)}
		</>
	);
}

export default LidBewerken;
